const NotFound = () => {
  return <h3>404 Page not found</h3>;
};

export default NotFound;
